import React, { ComponentProps, FC } from 'react';

import { HeaderContext } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import Divider from '@adsk/alloy-react-divider';
import {
  ColumnOption,
  TABLE_SIZES,
  TableConfigurationButton,
  TableConfigurationDensity,
  TableConfigurationReset,
} from '@adsk/alloy-react-table';
import { Flyout } from '@adsk/alloy-react-tooltip';

import { COLUMNS_IGNORE_LIST } from '../../../constants';

export const ConfigurationHeader: FC<
  {
    table: HeaderContext<EntitlementsProject, unknown>['table'];
  } & ComponentProps<typeof TableConfigurationDensity>
> = ({ table, tableSize, setSize }) => {
  const reset = () => {
    setSize(TABLE_SIZES.LARGE);
    table.toggleAllColumnsVisible(true);
    table.resetColumnOrder();
  };

  return (
    <Flyout
      shouldWrapChildren={true}
      containerPadding={0}
      placement={Flyout.PLACEMENTS.BOTTOM_END}
      content={
        <div data-testid="ConfigurationHeader">
          <div>
            {table
              .getAllLeafColumns()
              .filter((column) => !['actions'].includes(column.id))
              .map((column) => (
                <ColumnOption
                  disabled={COLUMNS_IGNORE_LIST.includes(column.id)}
                  key={column.id}
                  column={column}
                  getColumnName={(column) => {
                    const header = column.columnDef.header as () => string;
                    return header();
                  }}
                />
              ))}
          </div>
          <Divider />
          <TableConfigurationDensity tableSize={tableSize} setSize={setSize} />
          <Divider />
          <TableConfigurationReset reset={reset} />
        </div>
      }
    >
      <TableConfigurationButton />
    </Flyout>
  );
};
